<template>
  <v-row justify="center">
    <v-col class="auth-container">
      <v-row class="ma-2"><slot name="logo"></slot></v-row>
      <v-card class="elevation-12" tile :loading="loading">
        <v-row class="ma-0 pa-0">
          <v-col cols="8" class="ma-0 pa-0">
            <v-card-title>
              <h1>Sign in email sent</h1>
            </v-card-title>
            <v-card-subtitle>
              <h2 class="mt-2">Please check your inbox</h2>
            </v-card-subtitle>
            <v-card-text>
              <p>
                An email has been sent to
                <strong>{{ this.emailForSignIn }}</strong
                >.
              </p>
              <p>
                It contains a magic link that will automatically navigate you
                back to this website.
              </p>
            </v-card-text>
            <v-card-text></v-card-text>
            <v-card-actions class="px-4">
              <v-btn
                tile
                class="button background-color--inactive color--foreground"
                elevation="0"
                @click="changeEmail"
                :disabled="loading"
                >Change email</v-btn
              >
              <v-spacer> </v-spacer>
              <v-btn
                tile
                color="primary"
                class="button"
                elevation="0"
                :disabled="this.timeout > 0"
                @click="resendEmail"
                :loading="loading"
                >{{ resendBtnTitle }}</v-btn
              >
            </v-card-actions>
          </v-col>
          <v-col cols="4" class="pt-12">
            <v-img
              :src="require('@/assets/images/img-registration-three@3x.png')"
              max-width="293px"
              max-height="342px"
            ></v-img>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
  </v-row>
</template>


<script>
import { mapGetters, mapActions } from 'vuex'
import { functions } from '@/firebaseConfig'
export default {
  data: () => ({
    timeout: 60,
    loading: false,
  }),
  created() {
    this.countDownTimer()
  },
  computed: {
    ...mapGetters(['emailForSignIn']),
    resendBtnTitle() {
      if (this.timeout > 0) {
        return `Resend email (${this.timeout}s)`
      }
      return 'Resend email'
    },
  },
  methods: {
    ...mapActions(['setEmailForSignIn', 'showError', 'showSuccess']),
    countDownTimer() {
      if (this.timeout > 0) {
        setTimeout(() => {
          this.timeout -= 1
          this.countDownTimer()
        }, 1000)
      }
    },
    async resendEmail() {
      this.loading = true
      try {
        const emailSignInLink = functions.httpsCallable('auth-emailSignIn')
        await emailSignInLink({ email: this.email })
        this.$store.dispatch('setEmailForSignIn', this.email)
        this.showSuccess('Email sent')
      } catch (err) {
        console.error(err)
        this.showError(
          '<b>Failed to send email link.</b>\n' + err.message ??
            'Please try again later or contact our support.'
        )
      } finally {
        this.loading = false
      }
    },
    changeEmail() {
      this.$store.dispatch('setEmailForSignIn', null)
      this.$router.replace({ name: 'login' })
    },
  },
}
</script>